<template>
    <!-- компонент "шапки" тікету -->

    <div
        class="dropdown"
        v-if="perms[101] == true || perms[304] == true || perms[305] == true || perms[354] == true || perms[371] == true || perms[2000] == true"
    >
        <button 
            class="btn btn-ghost-secondary btn-icon btn-sm fs-16" 
            type="button" 
            data-bs-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
        >
            <i class="bx bx-dots-vertical-rounded align-bottom"></i>
        </button>

        <div 
            class="dropdown-menu dropdown-menu-end"
        >
            <!-- 
                Створити заявку
                - перевірка йде на права доступу 101 (створити заявку) або 2000 (режим бога)
            -->
            <button 
                class="dropdown-item" 
                v-if="perms[101] || perms[2000]" 
                @click="openapplicbox()"
            >
                {{ $t('Application') }}
            </button>

            <!-- 
                Додати нагадування в календар 
                - перевірка йде на налаштування до акаунту 026 (пропонувати створити нагадування) і статус - новий
            -->
            <button 
                class="dropdown-item" 
                v-if="this.checks['026'] == true && this.form.status == 'new'" 
                @click="addReminder()"
            >
                {{ $t('AddReminderInCalendar') }}
            </button>

            <!-- 
                Додати репорт до тікету
                - перевірка йде на права доступу 304 (створити репорт) або 2000 (режим бога) і статус - не має дорівнювати "закритий"
            -->
            <button 
                class="dropdown-item" 
                v-if="(perms[305] || perms[2000]) && this.form.status !== 'closed'" 
                @click="openreportBox()"
            >
                {{ $t('report') }}
            </button>  
            
            <!--
                Редагування тікету
                - перевірка йде на права доступу 304 (редагувати тікет) або 2000 (режим бога) і статус - має дорівнювати "новий", "очікує на взяття в роботу" або "в роботі"
            -->
            <button
                class="dropdown-item"
                v-if="(perms[304]) && (this.form.status == 'new' || this.form.status == 'wait_jobs' || this.form.status == 'jobs') || perms[2000]"
                @click="this.$emit('edit', this.form)"
            >
                {{ $t('Edit') }}
            </button>

            <!--
                Редагувати дедлайн
                - перевірка йде на права доступу 371(додати оновлення) разом з 372(редагувати оновлення), або 2000 (режим бога)
                - - йде перевірка на користувача, він має бути автором тікету, або тим хто взяв в роботу
            -->
            <button
                class="dropdown-item"
                v-if="(perms[2000] || (perms[371] == true && perms[372] == true))
                        && (this.user.userid === this.form.createWorkerId || this.form.inJobWorkers.find((el) => this.user.userid == el.workerId))"
                @click="this.$emit('getUpdates', this.obj)"
            >
                {{ $t('editDeadline') }}
            </button>
            
            <!-- 
                кнопка "Видалення людини з тікету" 
                - надає змогу видалити тікет
                - йде перевірка на права доступу під номером 303 (видалити тікет) та перевірка, щоб статус тікету не був "видалений" або "закритий тікет"
            -->
            <b-button 
                v-if="
                    (this.form.assignedWorkers.find(el => el.workerId == this.user.userid) ||
                    this.perms[2000] == true) &&
                    this.form.inJobWorkers.length > 0
                " 
                @click="this.$emit('kickUserReq', this.form.ticketId)" 
                class="dropdown-item"
            >
                {{ $t('kickUser') }}
            </b-button>

            <!-- 
                кнопка "Змінити рішення тікету" 
                - надає змогу видалити тікет
                - йде перевірка на права доступу під номером 303 (видалити тікет) та перевірка, щоб статус тікету не був "видалений" або "закритий тікет"
            -->
            <!-- <b-button 
                v-if="this.perms[2000] == true" 
                @click="this.$emit('kickUserReq', this.form.ticketId)" 
                class="dropdown-item"
            >
                {{ $t('ChangeTicketResolution') }}
            </b-button> -->


        </div>
    </div>

    <!-- Згорнути модальне вікно -->
    <!-- <button 
        type="button" 
        class="btn btn-soft-warning btn-icon btn-sm fs-16 close-btn-email" 
        
    >
        <span>_</span>
    </button> -->

    <!-- Кнопка додавання в обране (список юзера) -->
    <button 
        v-if="this.user.userid == '34' || this.user.userid == '32' || this.user.userid == '43' || this.user.userid == '52'"
        class="btn btn-ghost-warning btn-icon btn-sm fs-16" 
        @click="checkFavorite == false ? objFavorite.show = true : removeFavotire()" 
        :title="checkFavorite == false ? $t('AddtoFavorites') : $t('RemoveFromFavorites')"
    >
        <i :class="`bx ${checkFavorite == false ? 'bx-star' : 'bxs-star'} align-bottom`"></i>
    </button>

    <!-- Закрити модальне вікно тікету -->
    <button 
        type="button" 
        class="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email" 
        @click="$emit('close')"
    >
        <i class="ri-close-fill align-bottom"></i>
    </button>
        
    <!-- Вікно з підтвердженням зміни статусу рішення тікету на in_release -->
    <!-- <confirmChangeDecidedStatus 
        v-if="showConfirmChangeDecided"
        @close="showConfirmChangeDecided = false"
        @confirmDecidedTicket="changeDecidedStatus"
    /> -->

    <!-- Модальне вікно додавання клієнта в обрані -->
    <addFavorite
        v-if="objFavorite.show"
        @close="objFavorite.show = false"
        :obj="this.form"
        :objForm="objFavorite"
        @changeFav="checkFavorite = true"
    />

</template>

<script>
// import confirmChangeDecidedStatus from './formleft/activity/main/confirmChangeDecidedStatus';
import addFavorite from './favorites/add'
import { storeS } from '@/store';
import { Tickets } from "@/API.js"

let apiTickets = new Tickets();

export default {
    props: ['obj'],
    components:{
        addFavorite
        // confirmChangeDecidedStatus
    },
    data(){
        return {
            form: "",
            checkFavorite: false,
            showConfirmChangeDecided: false,
            objFavorite: {
                show: false,
                obj: {},
                permEdit: false,
            },
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(){
            this.form = this.obj
        },
        removeFavotire(){
            // Видаляємо акаунт з обраних

            let tickets = JSON.parse(localStorage.getItem('favoriteTickets')) || [];

            let targetTicket = this.form.ticketId;

            // Пошук індексу обраного акаунта за userPhone
            let indexToRemove = tickets.findIndex(acc => acc.ticketId === targetTicket);

            if (indexToRemove !== -1) {
                // Видаляємо акаунт за індексом
                tickets.splice(indexToRemove, 1);
                localStorage.setItem('favoriteTickets', JSON.stringify(tickets));
                this.checkFavorite = false
                this.$toast.success("numberRemovedfromFavorites");
            } else {
                this.$toast.error("AccountNotFoundinFavorites");
            }
        },
        opensmsbox(){
            this.$emit('opensmsbox')
        },
        openapplicbox(){
            this.$emit('openapplicbox')
        },
        opentaskBox(){
            this.$emit('opentaskBox')
        },
        openticketBox(){
            this.$emit('openticketBox')
        },
        openreportBox(){
            this.$emit('openreportBox')
        },
        addReminder(){
            this.$emit('addReminder');
        }
    },
    mounted(){
        // Отримайте поточний обраний масив тікетів з localStorage
        let tickets = JSON.parse(localStorage.getItem('favoriteTickets')) || [];

        // номер тікету, яке ми шукаємо
        let ticketToCheck = this.form.ticketId;

        // Перевіряємо, чи існує тікет в масиві
        let isIdList = tickets.some(item => item.ticketId === ticketToCheck);

        // isIdList має значення true, якщо id присутнє в масиві
        if (isIdList) {
            this.checkFavorite = true
        } else {
            this.checkFavorite = false
        }
    },
    computed:{
        perms(){
            return storeS.perms
        },
        checks(){
            return storeS.checks
        },
        user() {
            return storeS.userbase
        }
    }
}
</script>